import { PreviewReportLink } from './PreviewReportLink';
import styles from './ReportFooter.module.css';

export interface SignatureInfo {
  signerName: string;
  signedAt: string;
}

interface SignedFooterContentProps {
  signature?: SignatureInfo;
  previewHref?: string;
  onAddAddendum?: () => void;
  isAddingAddendum?: boolean;
  onViewHistory?: () => void;
  canFinalize: boolean;
}

export function SignedFooterContent({
  signature,
  previewHref,
  onAddAddendum,
  isAddingAddendum,
  onViewHistory,
  canFinalize,
}: SignedFooterContentProps) {
  const hasSignerName =
    signature?.signerName && signature.signerName.trim() !== '';

  return (
    <>
      {previewHref && <PreviewReportLink href={previewHref} />}

      <span className={styles.finalTag}>FINAL</span>

      <span className={styles.signatureInfo}>
        {hasSignerName ? (
          <>
            Signed by {signature.signerName} at {signature.signedAt}
          </>
        ) : (
          <>Signed at {signature?.signedAt}</>
        )}
      </span>

      {canFinalize && onAddAddendum && (
        <button
          type="button"
          className={styles.btnPrimary}
          onClick={onAddAddendum}
          disabled={isAddingAddendum}
        >
          {isAddingAddendum ? 'Adding Addendum...' : 'Add Addendum'}
        </button>
      )}

      {onViewHistory && (
        <button
          type="button"
          className={styles.iconButton}
          onClick={onViewHistory}
          aria-label="View Report History"
          title="View Report History"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </button>
      )}
    </>
  );
}
